export default __webpack_public_path__ + "static/media/gallery_02.02134c9b.jpg";